import { render } from "./ChangePwd.vue?vue&type=template&id=354cd8fb&scoped=true"
import script from "./ChangePwd.vue?vue&type=script&lang=ts"
export * from "./ChangePwd.vue?vue&type=script&lang=ts"

import "./ChangePwd.vue?vue&type=style&index=0&id=354cd8fb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-354cd8fb"

export default script